export const DOCUMENT_TYPE_SPECIAL_PRODUCTS = 'specialProducts';
